import type {ComponentProps} from 'react';
import {cn} from '../lib/cn';

export type FormBoxHeaderProps = ComponentProps<'h2'>;

export function Header({children, className, ...props}: FormBoxHeaderProps) {
  return (
    <h2
      className={cn(
        'm-0 flex items-center gap-2 self-stretch p-0 text-2xl font-semibold leading-normal text-[var(--form-box-title-color)]',
        className,
      )}
      {...props}
    >
      {children}
    </h2>
  );
}
